import type { HTMLAttributes, ReactNode } from 'react';

export interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  /** The leaf/current crumb (rendered with stronger color + medium weight). */
  here: ReactNode;
  /** Optional trailing scope label — when omitted, no separator is rendered. */
  scope?: ReactNode;
}

/**
 * Two-part breadcrumb — `<here>` / `<sep>` / `<scope>`. Matches dashboard.html
 * `.crumbs`. Used in the signed-in shell header.
 */
export function Breadcrumbs({
  here,
  scope,
  className,
  ...rest
}: BreadcrumbsProps) {
  const cls = ['pn-crumbs', className].filter(Boolean).join(' ');
  return (
    <nav className={cls} aria-label="Breadcrumb" {...rest}>
      <span className="pn-crumbs-here">{here}</span>
      {scope != null ? (
        <>
          <span className="pn-crumbs-sep" aria-hidden="true">
            /
          </span>
          <span className="pn-crumbs-scope">{scope}</span>
        </>
      ) : null}
    </nav>
  );
}
